module.exports = __webpack_public_path__ + "static/img/PL.aa9d201.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/PL.svg
// module id = 2iZa
// module chunks = 66